module.exports = __webpack_public_path__ + "static/img/white2.d7eb81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white2.png
// module id = RFKw
// module chunks = 1